/**
 * Utilitaires pour les fonctionnalités d'impression
 */

export interface PrintWindowConfig {
    width?: number;
    height?: number;
    title?: string;
}

/**
 * Ouvre une nouvelle fenêtre d'impression avec le HTML fourni
 * @param html - Le contenu HTML à imprimer
 * @param config - Configuration de la fenêtre
 * @returns Promise<void>
 */
export const openPrintWindow = async (html: string, config: PrintWindowConfig = {}): Promise<void> => {
    const { width = 800, height = 600, title = 'Impression' } = config;
    
    return new Promise((resolve, reject) => {
        console.log(`Ouverture de la fenêtre d'impression: ${title}`);
        
        const printWindow = window.open('', '_blank', `width=${width},height=${height}`);
        
        if (!printWindow) {
            const errorMsg = 'Impossible d\'ouvrir la fenêtre d\'impression (popup bloqué ?)';
            console.error(errorMsg);
            alert('Impossible d\'ouvrir la fenêtre d\'impression. Vérifiez que les popups ne sont pas bloqués.');
            reject(new Error(errorMsg));
            return;
        }

        try {
            console.log('Écriture du HTML dans la fenêtre...');
            printWindow.document.write(html);
            printWindow.document.close();
            console.log('HTML écrit avec succès');
            
            // Attendre que le contenu soit rendu avant d'imprimer
            setTimeout(() => {
                console.log('Focus sur la fenêtre d\'impression...');
                printWindow.focus();
                
                setTimeout(() => {
                    console.log('Déclenchement de l\'impression...');
                    printWindow.print();
                    resolve();
                }, 500);
            }, 100);
            
        } catch (error) {
            console.error('Erreur lors de l\'écriture du HTML:', error);
            reject(error);
        }
    });
};
